
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Device } from '~/interfaces/device.interface';
import { IDeviceGroup } from '~/interfaces/devicegroup.interface';
import FieldMixin from '~/mixins/field.mixin';
import { ConfigModule } from '~/store/modules/config';
import { DeviceGroupModule } from '~/store/modules/devicegroup';
import { DevicesModule } from '~/store/modules/devices';

@Component
export default class DeviceGroup extends Mixins(FieldMixin) {
    @Prop() deviceGroupId!: string;
    @Prop() device!: Device;
    localDeviceGroupId = '';

    get localDeviceGroup() {
        return DeviceGroupModule.deviceGroupById(this.localDeviceGroupId) as IDeviceGroup;
    }

    set localDeviceGroup(deviceGroup: IDeviceGroup) {
        this.localDeviceGroupId = deviceGroup._id.$id;
    }

    get deviceGroups() {
        const categories = ['clients', 'beta', 'dev'];

        const sortedGroups = categories.flatMap(category => {
            return DeviceGroupModule.deviceGroups
                .filter(group => group.category === category)
                .sort((a, b) => {
                    if (category === 'clients' && (a.default || b.default)) {
                        return a.default ? -1 : 1;
                    }
                    return a.name.localeCompare(b.name);
                });
        });

        return sortedGroups;
    }

    get readableDeviceGroup() {
        const deviceGroup = DeviceGroupModule.deviceGroupById(this.deviceGroupId);
        return deviceGroup ? deviceGroup.name : 'N/A';
    }

    get areDeviceGroupsLoading() {
        return DeviceGroupModule.areDeviceGroupsLoading;
    }

    get isApplyDisabled() {
        return this.localDeviceGroupId === this.deviceGroupId;
    }

    get currentGatewayType() {
        return DevicesModule.currentGateway?.type || '';
    }

    @Watch('deviceGroupId', { immediate: true })
    handler() {
        this.resetDeviceGroupId();
    }

    resetDeviceGroupId() {
        this.localDeviceGroupId = this.deviceGroupId;
    }

    setDeviceGroup() {
        DevicesModule.setDeviceGroup({
            deviceId: this.device.id,
            deviceGroupId: this.localDeviceGroupId,
        });
    }

    openDgm() {
        window.open(`${ConfigModule.dgmUrl}/${this.device.type}/${this.deviceGroupId}`);
    }

}
